// Generated by CoffeeScript 1.12.7
/* global window:false, document:false, Groupon:false, subs_bg_aspectRatio:false, fetch: false, I18n: false, subsI18n: false, OptimizeSuite: false, Cookie: falser, Optimize: false */

'use strict';

require('../../groupon/frontend/groupon.coffee');

require('../../subscription/frontend/email_suggest');

require('../../subscription/frontend/placeholder_input');

require('./subs_success_banner');

require('../../groupon/frontend/validate');

const ready = fn => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    // https://developer.mozilla.org/en-US/docs/Web/Events/DOMContentLoaded
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const triggerEvent = (el, type) => {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  } else {
    // IE 8
    const e = document.createEventObject();
    e.eventType = type;
    el.fireEvent(`on${e.eventType}`, e);
  }
};

const serialize = form => {
  let field, l;
  const s = [];
  if (typeof form === 'object' && form.nodeName === 'FORM') {
    const len = form.elements.length;
    for (let i = 0; i < len; i++) {
      field = form.elements[i];
      if (
        field.name &&
        !field.disabled &&
        field.type !== 'file' &&
        field.type !== 'reset' &&
        field.type !== 'submit' &&
        field.type !== 'button'
      ) {
        if (field.type === 'select-multiple') {
          l = form.elements[i].options.length;
          for (let j = 0; j < l; j++) {
            if (field.options[j].selected)
              s[s.length] = `${encodeURIComponent(
                field.name
              )}=${encodeURIComponent(field.options[j].value)}`;
          }
        } else if (
          (field.type !== 'checkbox' && field.type !== 'radio') ||
          field.checked
        ) {
          s[s.length] = `${encodeURIComponent(field.name)}=${encodeURIComponent(
            field.value
          )}`;
        }
      }
    }
  }
  return s.join('&').replace(/%20/g, '+');
};

Groupon.EmailZip = (function() {
  let updated_email_bg_position, updated_zip_bg_position;

  const success = 'js-success';

  const error = 'js-error';

  //postal_code = $('#postal_code_id');
  const postal_code = document.getElementById('potal_code_id');

  //email = $('#email_id');
  const email = document.getElementById('email_id');

  //submit_button = $('#submit_button');
  const submit_button = document.getElementById('submit_button');

  const hideBanner = document.getElementById('hide_banner');
  const noThx = document.getElementById('nothx');
  const closeId = document.getElementById('closeid');
  const continu = document.getElementById('continue');

  updated_email_bg_position = false;

  updated_zip_bg_position = false;

  if (email) {
    email.addEventListener('keydown', e => {
      if (
        e.keyCode === 13 &&
        !Groupon.EmailZip.validateAttributes(email, postal_code)
      ) {
        return e.preventDefault();
      }
    });

    email.addEventListener('keyup', e => {
      return Groupon.EmailZip.emailChanged(e);
    });

    email.addEventListener('change input', e => {
      return Groupon.EmailZip.emailChanged(e);
    });
  }

  if (postal_code) {
    postal_code.addEventListener('keyup', e => {
      return Groupon.EmailZip.postalCodeChanged(e);
    });

    postal_code.addEventListener('keydown', e => {
      if (
        e.keyCode === 13 &&
        !Groupon.EmailZip.validateAttributes(email, postal_code)
      ) {
        return e.preventDefault();
      }
    });

    postal_code.addEventListener('change', e => {
      return Groupon.EmailZip.postalCodeChanged(e);
    });
  }

  if (submit_button) {
    submit_button.addEventListener('click', e => {
      return Groupon.EmailZip.stepSubmit(e);
    });
  }

  if (hideBanner) {
    document.getElementById('hide_banner').addEventListener('click', e => {
      return Groupon.EmailZip.hideBanner(e);
    });
  }

  if (noThx) {
    document.getElementById('nothx').addEventListener('click', e => {
      Groupon.EmailZip.triggerClose();
      e.preventDefault();
      return true;
    });
  }

  if (closeId) {
    document.getElementById('closeid').addEventListener('click', e => {
      Groupon.EmailZip.triggerClose();
      e.preventDefault();
      return true;
    });
  }

  if (continu) {
    document.getElementById('continue').addEventListener('click', e => {
      Groupon.EmailZip.triggerClose();
      e.preventDefault();
      return true;
    });
  }

  ready(() => {
    let $bg, theWindow;
    const resizeSubsBg = function() {
      let newHeight, newWidth;
      if (
        theWindow.getBoundingRect().width / theWindow.getBoundingRect().height <
        subs_bg_aspectRatio
      ) {
        newWidth = theWindow.getBoundingRect().width * subs_bg_aspectRatio;
        $bg.style.top = '0px';
        $bg.style.height = `${theWindow.getBoundingRect().height}px`;
        $bg.style.width = `${newWidth}px`;
        $bg.style.left = `${(theWindow.getBoundingRect().width - newWidth) /
          2}px`;
      } else {
        newHeight = theWindow.getBoundingRect().width / subs_bg_aspectRatio;
        $bg.style.left = '0px';
        $bg.style.width = `${theWindow.getBoundingRect().width}px`;
        $bg.style.height = `${newHeight}px`;
        $bg.style.top = `${(theWindow.getBoundingRect().height - newHeight) /
          2}px`;
      }
    };
    theWindow = window;
    //$bg = $("#subscription-bg");
    $bg = document.getElementById('subscription-bg');
    if ($bg != null) {
      theWindow.resize(resizeSubsBg).resize();
    }
  });

  function EmailZip() {
    if (email) {
      email.emailSuggestions();
      email.placeholderInput();
      setTimeout(() => {
        return email.setCursorPosition(0);
      }, 100);
    }
    if (postal_code) {
      postal_code.placeholderInput();
    }
  }

  EmailZip.inputSuccessHandler = function(input) {
    input.classList.remove(error);
    input.classList.add(success);
    submit_button.removeAttribute('disabled');
  };

  EmailZip.errorHandler = function() {
    this.emailHandler();
    this.postalCodeHandler();
    submit_button.setAttribute('disabled', true);
  };

  EmailZip.inputErrorHandler = function(input) {
    input.classList.remove(success);
    input.classList.add(error);
    submit_button.setAttribute('disabled', true);
  };

  EmailZip.emailHandler = function(ev) {
    if (email) {
      if (this.validateEmail(email.value)) {
        this.inputSuccessHandler(email);
        if ((ev != null ? ev.keyCode : void 0) === 13) {
          submit_button.click();
        }
      } else if (
        email.getAttribute('placeholder') != null &&
        email.value === email.getAttribute('placeholder')
      ) {
        email.classList.remove(success);
        email.classList.remove(error);
      } else {
        return this.inputErrorHandler(email);
      }
    }
  };

  EmailZip.postalCodeHandler = function(ev) {
    if (postal_code) {
      if (this.validateZipCode(postal_code.value)) {
        this.inputSuccessHandler(postal_code);
        if ((ev != null ? ev.keyCode : void 0) === 13) {
          return submit_button.click();
        }
      } else if (
        postal_code.getAttribute('placeholder') != null &&
        postal_code.value === postal_code.getAttribute('placeholder')
      ) {
        postal_code.classList.remove(success);
        postal_code.classList.remove(error);
      } else {
        return this.inputErrorHandler(postal_code);
      }
    }
  };

  EmailZip.emailChanged = function(ev) {
    if (this.completed) {
      return;
    }
    if (!updated_email_bg_position) {
      if (
        !document.body.classList.contains('rtl') &&
        !document.getElementById('sub_dlg').classList.contains('centered')
      ) {
        email.style.backgroundPosition = `${email.width() + 12}px`;
      }
      updated_email_bg_position = true;
    }
    this.emailHandler(ev);
    if (ev.currentTarget.value === '') {
      email.classList.remove(error);
    }
  };

  EmailZip.postalCodeChanged = function(ev) {
    if (!updated_zip_bg_position) {
      if (!document.body.classList.contains('rtl')) {
        postal_code.style.backgroundPosition = `${postal_code.getBoundingRect()
          .width + 12}px`;
      }
      updated_zip_bg_position = true;
    }
    if (this.completed) {
      return;
    }
    this.postalCodeHandler(ev);
    if (ev.currentTarget.value === '') {
      postal_code.classList.remove(error);
    }
  };

  EmailZip.stepSubmit = function(ev) {
    ev.preventDefault();
    if (this.validateAttributes(email, postal_code)) {
      this.completed = true;
      let temp;
      if ((temp = document.getElementById('sub_dlg'))) {
        triggerEvent(temp, 'dismiss');
      }
      if ((temp = document.getElementById('sub_non_modal'))) {
        triggerEvent(temp, 'dismiss');
      }
      if ((temp = document.getElementById('js-zip-modal-step'))) {
        triggerEvent(temp, 'dismiss');
      }
      //let formData = serialize(ev.currentTarget.form);
      const formData = serialize(ev.currentTarget.form);
      const url = ev.currentTarget.form.action;
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'ajax',
        },
        body: formData,
        mode: 'cors',
        redirect: 'follow',
      })
        .then(xhr => {
          if (!xhr.ok) {
            let i18nObj;
            i18nObj = I18n;
            if (typeof subsI18n !== 'undefined' && subsI18n !== null) {
              i18nObj = subsI18n;
            }
            const bannerText = i18nObj.translate(
              'js.modules.subscription.subscription_failure',
              {
                link_open:
                  "<a href='#' onclick='retrySubscriptionAfterFailure()'>",
                link_close: '</a>',
              }
            );
            window.create_subscription_result_banner(
              'error',
              bannerText,
              'block'
            );
            OptimizeSuite.TrackingHub.add('goalEmailZip', {
              goalType: 'subscription',
              fail: xhr.responseText,
            });
            if (document.getElementById('sub_dlg'))
              triggerEvent(document.getElementById('sub_dlg'), 'fail');
            if (document.getElementById('sub_non_modal'))
              triggerEvent(document.getElementById('sub_non_modal'), 'fail');
            throw 'Error in subscribing';
          } else {
            return xhr.json();
          }
        })
        .then(data => {
          let i18nObj, ref, ref1, ref2, successStringKey;
          i18nObj = I18n;
          successStringKey = 'js.modules.subscription.subscription_success';
          if (typeof subsI18n !== 'undefined' && subsI18n !== null) {
            i18nObj = subsI18n;
          }
          if (
            data.incentiveStatus != null &&
            data.incentiveStatus === 'success'
          ) {
            successStringKey =
              'js.modules.subscription.subscription_success_subsave';
          }
          const bannerText = i18nObj.translate(successStringKey, {
            division: data.divisionName,
            email: email.value,
          });
          window.create_subscription_result_banner(
            'success',
            bannerText,
            'block'
          );
          if (window._subscriptionSuccessCallback != null) {
            window._subscriptionSuccessCallback(
              data.divisionId,
              postal_code ? postal_code.value : null
            );
          }
          OptimizeSuite.TrackingHub.add('goalEmailZip', {
            goalType: 'subscription',
            goalId: data.subscriptionId,
          });
          const lastEventId =
            OptimizeSuite.getLastEventId != null
              ? OptimizeSuite.getLastEventId()
              : window.Cookie.get('bh-last-event-id');
          OptimizeSuite.InteractionGoals.subscription({
            scid: Cookie.get('scid'),
            division:
              typeof Optimize !== 'undefined' && Optimize !== null
                ? (ref = Optimize.suiteData) != null
                  ? ref.division
                  : void 0
                : void 0,
            country:
              typeof Optimize !== 'undefined' && Optimize !== null
                ? (ref1 = Optimize.suiteData) != null
                  ? ref1.country
                  : void 0
                : void 0,
            channel:
              typeof Optimize !== 'undefined' && Optimize !== null
                ? (ref2 = Optimize.suiteData) != null
                  ? ref2.channel
                  : void 0
                : void 0,
            clickId: lastEventId,
            consumerId: data.consumerId,
          });
          if (data.doiTreatment === 'hard') {
            if (document.getElementById('double_optin'))
              document.getElementById('double_optin').value = 'true';
          }
          let temp1;
          if ((temp1 = document.getElementById('sub_dlg'))) {
            triggerEvent(temp1, 'success');
          }
          if ((temp1 = document.getElementById('sub_non_modal'))) {
            triggerEvent(temp1, 'success');
          }
          if ((temp1 = document.getElementById('js-zip-modal-step'))) {
            triggerEvent(temp1, 'success');
          }
        });
      return false;
    } else {
      return this.errorHandler();
    }
  };

  EmailZip.hideBanner = function() {
    Cookie.set('close_subscribe_drawer', true, {
      maxAge: 24 * 60 * 60 * 1000,
      domain: document.domain,
    });
    triggerEvent(document.getElementById('sub_non_modal'), 'dismiss');
  };

  EmailZip.triggerClose = function() {
    if (document.getElementById('sub_dlg') != null) {
      triggerEvent(document.getElementById('sub_dlg'), 'close');
    }
    if (document.getElementById('js-zip-modal-step') != null) {
      triggerEvent(document.getElementById('js-zip-modal-step'), 'close');
    }
  };

  EmailZip.validateAttributes = function(_email, zip) {
    return (
      (zip === null || this.validateZipCode(zip.value)) &&
      this.validateEmail(_email.value)
    );
  };

  EmailZip.validateEmail = function(_email) {
    if (_email == null || _email === '') {
      return false;
    }
    return Groupon.Validate.email(_email);
  };

  EmailZip.validateZipCode = function(zip) {
    if (zip == null || zip === '') {
      return false;
    }
    return Groupon.Validate.zip(zip);
  };

  return EmailZip;
})();

new Groupon.EmailZip();
